import React from 'react';
import { IconSvgProps } from '@models/common';

const AILogo: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'>
      <path
        fill='currentColor'
        d='M7.685 5.621c.275-.74 1.324-.74 1.598 0l1.52 4.097a.85.85 0 0 0 .503.502l4.106 1.516c.741.274.741 1.32 0 1.594l-4.106 1.516a.853.853 0 0 0-.504.502l-1.519 4.097c-.274.74-1.323.74-1.598 0l-1.52-4.097a.85.85 0 0 0-.503-.502L1.556 13.33c-.741-.274-.741-1.32 0-1.594l4.106-1.516a.852.852 0 0 0 .504-.502L7.685 5.62Zm11.04-1.436a.284.284 0 0 1 .532 0l.916 2.468a.284.284 0 0 0 .167.168l2.475.913a.283.283 0 0 1 0 .532l-2.475.913a.283.283 0 0 0-.167.167l-.916 2.469a.284.284 0 0 1-.533 0l-.915-2.468a.282.282 0 0 0-.168-.168l-2.474-.913a.283.283 0 0 1 0-.532l2.474-.913a.285.285 0 0 0 .168-.167l.915-2.469Z'
      />
    </svg>
  );
};

export default AILogo;
